<template>
  <div id="app">
    <div id="content">
      <Header
        @update="update()"
        :page="'team_edit'"
        :title_one="'team'"
        :title_two="'edit'"
        :action_one="'save'"
        :action_two="'cancel'"
      ></Header>

      <div class="form">
        <h2 class="title">{{ $t("edit") }} {{ $t("team") }}</h2>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <div class="box">
              <!-- TEAM NAME -->
              <div class="item">
                <label
                  >{{ $t("params.name") }}
                  <!-- <span class="obligatory">*</span> -->
                </label>
                <input
                  class="upper"
                  :class="error.name ? 'error' : ''"
                  type="text"
                  v-model="input.name"
                  :placeholder="$t('params.name')"
                  disabled
                />
              </div>

              <!-- TEAM IMAGE -->
              <div class="item">
                <div class="image">
                  <ClipperImage
                    v-if="clipper"
                    :image="clipper"
                    :ratio="16 / 9"
                    :area="90"
                    @getImage="showThumb"
                  ></ClipperImage>
                  <label
                    >{{ $t("params.photo") }}
                    <!-- <span class="obligatory">*</span> -->
                  </label>
                  <img
                    @click="addThumbnail()"
                    v-if="photo_preview"
                    :src="photo_preview"
                  />
                  <div @click="addThumbnail()" v-else class="addThumb">
                    <div class="add" :class="{ error: error.photo }">
                      <v-icon x-large>add</v-icon>
                      <div class="text">
                        {{ $t("add") + " " + $t("params.photo") }}
                      </div>
                    </div>
                  </div>
                  <input
                    type="file"
                    style="display: none"
                    :ref="'image_input'"
                    accept="image/png, image/jpeg"
                    @change="onThumbnailPicked"
                  />
                </div>
                <span :class="{ error: error.photo_size }">{{
                  $t("descriptions.file_size", { s: "1MB" })
                }}</span>
              </div>

              <span class="obligatory" v-if="error.duplicatedUniforms">{{
                $t("errors.duplicated_uniforms")
              }}</span>

              <!-- 1st EQUIPMENT -->
              <div class="item">
                <h6>{{ $t("params.local_uniform") }}</h6>
                <v-radio-group
                  v-on:change="changeMode(1)"
                  v-model="local_equipment_mode"
                  row
                >
                  <v-radio
                    :label="$t('params.club_uniform')"
                    value="1"
                  ></v-radio>
                  <v-radio
                    :label="$t('params.new_uniform')"
                    value="2"
                  ></v-radio>
                </v-radio-group>

                <div class="content" v-if="Object.keys(uniforms).length > 0">
                  <label>{{ $t("descriptions.choose_equipment") }}</label>
                  <!-- <select v-if="local_equipment_mode == '1'" v-model="local_equipment" :class="error.local_equipment_selected ? 'error' : ''" >
                              <option v-for="uniform in uniforms" v-bind:value="uniform" v-bind:key="uniform.id">
                                {{uniform.primary_color + " " + uniform.type + " " + (uniform.secondary_color ? uniform.secondary_color : '' )}}
                              </option>
                            </select> -->
                  <div
                    v-if="local_equipment_mode == '1'"
                    class="equipments card"
                  >
                    <!-- <div class="single" v-for="uniform in uniforms" v-bind:key="uniform.id">
                                <template v-if="team.event">
                                  <Equipment
                                    :class="[{'selected': local_equipment.id == uniform.id}, error.local_equipment_selected ? 'error' : '']"
                                    @click="local_equipment = uniform"
                                    :equipment="uniform"
                                    :error="error.local_equipment"
                                    :is_preview="local_equipment_is_preview"
                                    :sport="team.event.sport">
                                  </Equipment>
                                </template>
                                <div class="actions" @click="uniformForm(uniform.id,1)">
                                  {{$t('edit')}}
                                </div>
                              </div> -->

                    <SliderUniform
                      :uniforms="uniforms"
                      :error="error.duplicatedUniforms"
                      :is_preview="local_equipment_is_preview"
                      :sport="team.event.sport"
                      :mode="1"
                      :assigned_uniform="local_equipment"
                      @selected="selectedUniform"
                      @edit="uniformForm"
                    ></SliderUniform>
                  </div>
                  <div v-else class="equipments">
                    <template v-if="team.event">
                      <Equipment
                        :equipment="local_equipment"
                        :error="error.local_equipment"
                        :is_preview="local_equipment_is_preview"
                        :sport="team.event.sport"
                      ></Equipment>
                    </template>
                  </div>
                </div>
                <div class="content" v-else>
                  <select
                    v-if="local_equipment_mode == '1'"
                    disabled
                    :class="error.local_equipment_selected ? 'error' : ''"
                  >
                    <option disabled selected>{{
                      $t("descriptions.no_equipments")
                    }}</option>
                  </select>
                  <template v-if="team.event">
                    <Equipment
                      :equipment="local_equipment"
                      :error="error.local_equipment"
                      :is_preview="local_equipment_is_preview"
                      :sport="team.event.sport"
                    ></Equipment>
                  </template>
                </div>
              </div>

              <!-- 2nd EQUIPMENT -->
              <div class="item">
                <h6>{{ $t("params.visit_uniform") }}</h6>
                <v-radio-group
                  v-on:change="changeMode(2)"
                  v-model="away_equipment_mode"
                  row
                >
                  <v-radio
                    :label="$t('params.club_uniform')"
                    value="1"
                  ></v-radio>
                  <v-radio
                    :label="$t('params.new_uniform')"
                    value="2"
                  ></v-radio>
                </v-radio-group>

                <div class="content" v-if="Object.keys(uniforms).length > 0">
                  <label>{{ $t("descriptions.choose_equipment") }}</label>
                  <!-- <select v-if="away_equipment_mode == '1'" v-model="away_equipment" :class="error.away_equipment_selected ? 'error' : ''" >
                              <option v-for="uniform in uniforms" v-bind:value="uniform" v-bind:key="uniform.id">
                                {{uniform.primary_color + " " + uniform.type + " " + (uniform.secondary_color ? uniform.secondary_color : '' )}}
                              </option>
                            </select> -->
                  <div
                    v-if="away_equipment_mode == '1'"
                    class="equipments card"
                  >
                    <!-- <div class="single" v-for="uniform in uniforms" v-bind:key="uniform.id" >
                                <template v-if="team.event">
                                  <Equipment
                                    :class="[{'selected': away_equipment.id == uniform.id}, error.away_equipment_selected ? 'error' : '']"
                                    @click="away_equipment = uniform"
                                    :equipment="uniform"
                                    :error="error.away_equipment"
                                    :is_preview="away_equipment_is_preview"
                                    :sport="team.event.sport">
                                  </Equipment>
                                </template>
                                <div class="actions" @click="uniformForm(uniform.id,2)">
                                  {{$t('edit')}}
                                </div>
                              </div> -->

                    <SliderUniform
                      :uniforms="uniforms"
                      :error="error.duplicatedUniforms"
                      :is_preview="away_equipment_is_preview"
                      :sport="team.event.sport"
                      :mode="2"
                      :assigned_uniform="away_equipment"
                      @selected="selectedUniform"
                      @edit="uniformForm"
                    ></SliderUniform>
                  </div>
                  <div v-else class="equipments">
                    <template v-if="team.event">
                      <Equipment
                        :equipment="away_equipment"
                        :error="error.away_equipment"
                        :is_preview="away_equipment_is_preview"
                        :sport="team.event.sport"
                      ></Equipment>
                    </template>
                  </div>
                </div>
                <div class="content" v-else>
                  <select
                    v-if="away_equipment_mode == '1'"
                    disabled
                    :class="error.away_equipment_selected ? 'error' : ''"
                  >
                    <option disabled selected>{{
                      $t("descriptions.no_equipments")
                    }}</option>
                  </select>
                  <template v-if="team.event">
                    <Equipment
                      :equipment="away_equipment"
                      :error="error.away_equipment"
                      :is_preview="away_equipment_is_preview"
                      :sport="team.event.sport"
                    ></Equipment>
                  </template>
                </div>
              </div>
            </div>

            <ErrorPopup
              @close="closePopup()"
              @input="closePopup()"
              :dialog="dialog"
            ></ErrorPopup>

            <v-dialog
              v-model="dialog2"
              :scrollable="true"
              width="900"
              height="700px"
              style="overflow: hidden !important"
              class="modal"
              data-app
            >
              <div id="uniform_form">
                <div class="body">
                  <h2>{{ $t("params.edit_uniform") }}</h2>
                  <template v-if="team.event">
                    <Equipment
                      class="equipment"
                      :equipment="uniform_edit"
                      :error="error.uniform_edit"
                      :sport="team.event.sport"
                    ></Equipment>
                  </template>
                </div>
                <div class="buttons">
                  <!-- <v-btn @click="closePopup2()" class="button cancel">{{$t('cancel')}}</v-btn>
                            <v-btn @click="saveUniform()" class="button add">{{$t('save')}}</v-btn> -->

                  <div class="btn" v-on:click="closePopup2()" id="cancel">
                    {{ $t("cancel") }}
                  </div>
                  <div v-on:click="saveUniform()" class="btn" id="add">
                    {{ $t("save") }}
                  </div>
                </div>
              </div>
            </v-dialog>
          </v-layout>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Equipment from "@/components/ui/Equipment.vue";
import ClipperImage from "@/components/ui/ClipperImage.vue";
import Header from "@/components/layout/Header";
import ErrorPopup from "@/components/ui/ErrorPopup.vue";
import SliderUniform from "@/components/ui/SliderUniform.vue";

export default {
  name: "TeamEdit",
  components: {
    Equipment,
    ClipperImage,
    Header,
    ErrorPopup,
    SliderUniform
  },
  data() {
    return {
      user: {},
      team: {},
      club: {},
      uniforms: {},
      photo_preview: "",
      clipper: false,
      local_equipment_mode: "1",
      away_equipment_mode: "1",
      local_equipment_is_preview: true,
      away_equipment_is_preview: true,
      dialog: false,
      dialog2: false,
      uniform_edit: {
        primary_color: "",
        secondary_color: "",
        type: "",
        pants_color: "",
        socks_color: ""
      },
      unifrom_edit_id: -1,
      uniform_edit_type: 0,
      input: {
        name: "",
        photo: "",
        // inputs for api
        local_equipment_id: "",
        local_equipment_primary_color: "",
        local_equipment_type: "",
        local_equipment_secondary_color: "",
        local_equipment_pants_color: "",
        local_equipment_socks_color: "",
        local_equipment_club_uniform: "",

        away_equipment_id: "",
        away_equipment_primary_color: "",
        away_equipment_type: "",
        away_equipment_secondary_color: "",
        away_equipment_pants_color: "",
        away_equipment_socks_color: "",
        away_equipment_club_uniform: ""
      },
      local_equipment: {
        primary_color: "",
        secondary_color: "",
        type: "",
        pants_color: "",
        socks_color: ""
      },
      away_equipment: {
        primary_color: "",
        secondary_color: "",
        type: "",
        pants_color: "",
        socks_color: ""
      },
      error: {
        name: false,
        photo: false,
        local_equipment: {
          primary_color: false,
          secondary_color: false,
          type: false,
          pants_color: false,
          socks_color: false
        },
        local_equipment_selected: false,
        away_equipment: {
          primary_color: false,
          secondary_color: false,
          type: false,
          pants_color: false,
          socks_color: false
        },
        away_equipment_selected: false,
        uniform_edit: {
          primary_color: false,
          secondary_color: false,
          type: false,
          pants_color: false,
          socks_color: false
        },
        duplicatedUniforms: false,
        photo_size: false
      }
    };
  },
  created() {
    this.user = this.$store.getters["user/getUser"];
    var self = this;
    if (this.user.admin) {
      this.$store
        .dispatch("club/loadClubEvent", {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        })
        .then(function() {
          // get data
          var data = { ...self.$store.getters["club/getClub"] };
          self.club = data;
          self.team = data.teams[self.$route.params.id]
            ? data.teams[self.$route.params.id]
            : {};
          self.input.name = self.team.name;
          self.input.photo = self.team.photo;
          self.photo_preview = self.input.photo;
          self.uniforms = data.uniforms;

          // check if team has local uniform
          if (self.team.local_uniform != null) {
            self.local_equipment = self.team.local_uniform;
          } else if (Object.keys(self.uniforms).length > 0) {
            self.local_equipment = self.uniforms[Object.keys(self.uniforms)[0]];
          }

          // check if team has away uniform
          if (self.team.away_uniform != null) {
            self.away_equipment = self.team.away_uniform;
          } else if (Object.keys(self.uniforms).length > 0) {
            self.away_equipment = self.uniforms[Object.keys(self.uniforms)[0]];
          }
        });
    } else {
      // load team information
      this.$store
        .dispatch("team/loadTeam", { team_id: this.$route.params.id })
        .then(function() {
          var data = self.$store.getters["team/getTeam"];
          self.team = data.team;
          self.club = data.club;
          self.input.name = data.team.name;
          self.input.photo = data.team.photo;
          self.photo_preview = self.input.photo;

          // check if team has local uniform
          if (self.team.local_uniform != null) {
            self.local_equipment = self.team.local_uniform;
          }

          // check if team has away uniform
          if (self.team.away_uniform != null) {
            self.away_equipment = self.team.away_uniform;
          }

          // load equipments information
          self.$store
            .dispatch("team/loadUniforms", { club_id: self.club.id })
            .then(function() {
              self.uniforms = self.$store.getters["team/getUniforms"];

              if (
                self.team.local_uniform == null &&
                Object.keys(self.uniforms).length > 0
              ) {
                self.local_equipment =
                  self.uniforms[Object.keys(self.uniforms)[0]];
              }

              if (
                self.team.away_uniform == null &&
                Object.keys(self.uniforms).length > 0
              ) {
                self.away_equipment =
                  self.uniforms[Object.keys(self.uniforms)[0]];
              }
            });
        });
    }
  },

  methods: {
    validate() {
      var validate = true;

      // validate name
      // if(isEmpty(this.input.name)){
      //   this.error.name = true;
      //   validate = false;
      // } else {
      //   this.error.name = false;
      // }

      // validate if isn't selected club equipment
      if (
        this.local_equipment_mode == "1" &&
        typeof this.local_equipment.id == "undefined"
      ) {
        this.error.local_equipment_selected = true;
        validate = false;
        console.log("ERROR");
      } else {
        this.error.local_equipment_selected = false;
      }

      // local equipment
      // validate primary_color
      if (isEmpty(this.local_equipment.primary_color)) {
        this.error.local_equipment.primary_color = true;
        validate = false;
        console.log("ERROR 1");
      } else {
        this.error.local_equipment.primary_color = false;
      }
      // validate type
      if (isEmpty(this.local_equipment.type)) {
        this.error.local_equipment.type = true;
        validate = false;
        console.log("ERROR 2");
      } else {
        this.error.local_equipment.type = false;
      }
      // validate secondary_color
      if (
        isEmpty(this.local_equipment.secondary_color) &&
        this.local_equipment.type != "one_colour"
      ) {
        this.error.local_equipment.secondary_color = true;
        validate = false;
        console.log("ERROR 3");
      } else {
        this.error.local_equipment.secondary_color = false;
      }
      // validate pants_color
      if (isEmpty(this.local_equipment.pants_color)) {
        this.error.local_equipment.pants_color = true;
        validate = false;
      } else {
        this.error.local_equipment.pants_color = false;
      }
      // validate socks_color
      if (
        isEmpty(this.local_equipment.socks_color) &&
        this.team.event.sport == "football"
      ) {
        this.error.local_equipment.socks_color = true;
        validate = false;
      } else {
        this.error.local_equipment.socks_color = false;
      }

      // validate if isn't selected club equipment
      if (
        this.away_equipment_mode == "1" &&
        typeof this.away_equipment.id == "undefined"
      ) {
        this.error.away_equipment_selected = true;
        validate = false;
      } else {
        this.error.away_equipment_selected = false;
      }

      // visit equipment
      // validate primary_color
      if (isEmpty(this.away_equipment.primary_color)) {
        this.error.away_equipment.primary_color = true;
        validate = false;
      } else {
        this.error.away_equipment.primary_color = false;
      }
      // validate type
      if (isEmpty(this.away_equipment.type)) {
        this.error.away_equipment.type = true;
        validate = false;
      } else {
        this.error.away_equipment.type = false;
      }
      // validate secondary_color
      if (
        isEmpty(this.away_equipment.secondary_color) &&
        this.away_equipment.type != "one_colour"
      ) {
        this.error.away_equipment.secondary_color = true;
        validate = false;
      } else {
        this.error.away_equipment.secondary_color = false;
      }
      // validate pants_color
      if (isEmpty(this.away_equipment.pants_color)) {
        this.error.away_equipment.pants_color = true;
        validate = false;
      } else {
        this.error.away_equipment.pants_color = false;
      }
      // validate socks_color
      if (
        isEmpty(this.away_equipment.socks_color) &&
        this.team.event.sport == "football"
      ) {
        this.error.away_equipment.socks_color = true;
        validate = false;
      } else {
        this.error.away_equipment.socks_color = false;
      }

      if (validate) {
        // validate if local uniform is the same as the visit uniform
        if (
          validate &&
          this.uniformsAreEquals(
            this.local_equipment,
            this.away_equipment,
            this.team.event.sport
          )
        ) {
          this.error.duplicatedUniforms = true;

          this.error.local_equipment.primary_color = true;
          this.error.local_equipment.secondary_color = true;
          this.error.local_equipment.type = true;
          this.error.local_equipment.pants_color = true;
          if (this.team.event.sport == "football")
            this.error.local_equipment.socks_color = true;

          this.error.away_equipment.primary_color = true;
          this.error.away_equipment.secondary_color = true;
          this.error.away_equipment.type = true;
          this.error.away_equipment.pants_color = true;
          if (this.team.event.sport == "football")
            this.error.away_equipment.socks_color = true;

          validate = false;
        } else {
          this.error.duplicatedUniforms = false;

          this.error.local_equipment.primary_color = false;
          this.error.local_equipment.secondary_color = false;
          this.error.local_equipment.type = false;
          this.error.local_equipment.pants_color = false;
          if (this.team.event.sport == "football")
            this.error.local_equipment.socks_color = false;

          this.error.away_equipment.primary_color = false;
          this.error.away_equipment.secondary_color = false;
          this.error.away_equipment.type = false;
          this.error.away_equipment.pants_color = false;
          if (this.team.event.sport == "football")
            this.error.away_equipment.socks_color = false;
        }
      }

      // validate for new image
      if (this.input.photo) {
        // validate size (200KB max)
        console.log(this.input.photo);
        console.log(this.input.photo.size / 1024);
        console.log(this.input.photo.size / 1024 > 1024);
        if (this.input.photo.size / 1024 > 1024) {
          validate = false;
          this.error.photo = true;
          this.error.photo_size = true;
        } else {
          this.error.photo = false;
          this.error.photo_size = false;
        }
      }

      return validate;
    },

    update() {
      if (this.validate()) {
        // local equipment

        // id
        typeof this.local_equipment.id !== "undefined"
          ? (this.input.local_equipment_id = this.local_equipment.id)
          : (this.input.local_equipment_id = "");

        // mode
        this.input.local_equipment_club_uniform =
          this.local_equipment_mode == "1"
            ? (this.input.local_equipment_club_uniform = 1)
            : (this.input.local_equipment_club_uniform = 2);

        // avoid errors with ids
        if (this.input.local_equipment_club_uniform == 2)
          this.input.local_equipment_id = "";

        // uniform
        this.input.local_equipment_primary_color = this.local_equipment.primary_color;
        this.input.local_equipment_type = this.local_equipment.type;
        this.input.local_equipment_secondary_color = this.local_equipment.secondary_color;
        this.input.local_equipment_pants_color = this.local_equipment.pants_color;
        this.input.local_equipment_socks_color = this.local_equipment.socks_color;
        // check for one_colour
        if (this.input.local_equipment_type == "one_colour")
          this.input.local_equipment_secondary_color = "";

        // away equipment

        // id
        typeof this.away_equipment.id !== "undefined"
          ? (this.input.away_equipment_id = this.away_equipment.id)
          : (this.input.away_equipment_id = "");

        // mode
        this.input.away_equipment_club_uniform =
          this.away_equipment_mode == "1"
            ? (this.input.away_equipment_club_uniform = 1)
            : (this.input.away_equipment_club_uniform = 2);

        // avoid errors with ids
        if (this.input.away_equipment_club_uniform == 2)
          this.input.away_equipment_id = "";

        // uniform
        this.input.away_equipment_primary_color = this.away_equipment.primary_color;
        this.input.away_equipment_type = this.away_equipment.type;
        this.input.away_equipment_secondary_color = this.away_equipment.secondary_color;
        this.input.away_equipment_pants_color = this.away_equipment.pants_color;
        this.input.away_equipment_socks_color = this.away_equipment.socks_color;
        // check for one_colour
        if (this.input.away_equipment_type == "one_colour")
          this.input.away_equipment_secondary_color = "";

        var self = this;
        // check if isn't required upload
        if (this.input.photo == this.photo_preview) {
          this.$store
            .dispatch("team/updateTeam", {
              team_id: self.team.id,
              input: self.input
            })
            .then(function() {
              self.$router.push({ name: "team" });
            });
        } else {
          this.$store
            .dispatch("team/upload", {
              team_id: self.team.id,
              input: self.input
            })
            .then(function() {
              self.$router.push({ name: "team" });
            });
        }
      } else {
        this.dialog = true;
      }
    },

    addThumbnail() {
      this.$refs["image_input"].click();
    },

    onThumbnailPicked(e) {
      const files = e.target.files;
      var self = this;
      if (files[0] !== undefined) {
        if (this.clipper) URL.revokeObjectURL(this.clipper);
        this.clipper = window.URL.createObjectURL(e.target.files[0]);
      }
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    resizeToWebP(dataURL, maxW = 1024, maxH = 1024, quality = 0.8) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
          let w = img.width, h = img.height;
          if (w > maxW) { h = h * (maxW / w); w = maxW; }
          if (h > maxH) { w = w * (maxH / h); h = maxH; }
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/webp', quality));
        };
        img.src = dataURL;
      });
    },

    async showThumb(image) {
      const webpDataURL = await this.resizeToWebP(image, 1024, 1024, 0.8);
      const fileName = `photo_${Date.now()}.webp`;
      this.input.photo = this.dataURLtoFile(webpDataURL, fileName);
      this.photo_preview = webpDataURL;
      this.clipper = false;
    },

    /**
     * type == 1 : local
     * type == 2 : away
     */
    changeMode(type) {
      if (type == 1) {
        this.local_equipment = {
          primary_color: "",
          secondary_color: "",
          type: "",
          pants_color: "",
          socks_color: ""
        };
      }
      if (type == 2) {
        this.away_equipment = {
          primary_color: "",
          secondary_color: "",
          type: "",
          pants_color: "",
          socks_color: ""
        };
      }
    },

    closePopup() {
      this.dialog = false;
    },

    uniformForm(id, type) {
      this.dialog2 = true;
      this.unifrom_edit_id = id;
      this.uniform_edit = { ...this.uniforms[id] };
      this.uniform_edit_type = type;
    },

    closePopup2() {
      // close popup
      this.dialog2 = false;

      // clear popup
      this.clearPopup(1);
    },

    saveUniform() {
      // clear popup
      this.clearPopup(0);

      let validate = true;

      // validate primary_color
      if (isEmpty(this.uniform_edit.primary_color)) {
        this.error.uniform_edit.primary_color = true;
        validate = false;
      } else {
        this.error.uniform_edit.primary_color = false;
      }

      // validate type
      if (isEmpty(this.uniform_edit.type)) {
        this.error.uniform_edit.type = true;
        validate = false;
      } else {
        this.error.uniform_edit.type = false;
      }

      // validate secondary_color
      if (
        isEmpty(this.uniform_edit.secondary_color) &&
        this.uniform_edit.type != "one_colour"
      ) {
        this.error.uniform_edit.secondary_color = true;
        validate = false;
      } else {
        this.error.uniform_edit.secondary_color = false;
      }

      // validate pants_color
      if (isEmpty(this.uniform_edit.pants_color)) {
        this.error.uniform_edit.pants_color = true;
        validate = false;
      } else {
        this.error.uniform_edit.pants_color = false;
      }

      // validate socks_color
      if (isEmpty(this.uniform_edit.socks_color)) {
        this.error.uniform_edit.socks_color = true;
        validate = false;
      } else {
        this.error.uniform_edit.socks_color = false;
      }

      // check if valit uniform
      if (validate) {
        // close uniforms.
        let uniforms = { ...this.uniforms };

        // save new uniforms.
        uniforms[this.unifrom_edit_id] = this.uniform_edit;

        // assign new object to uniforms.
        this.uniforms = uniforms;

        // check uniform type, and save
        this.uniform_edit_type == "1"
          ? (this.local_equipment = this.uniform_edit)
          : (this.away_equipment = this.uniform_edit);

        // close popup
        this.closePopup2();
      }
    },

    /**
     * type == 1 ? clear all
     * type == 2 ? only errors
     */
    clearPopup(type = 0) {
      if (type == 1) {
        // remove id
        this.unifrom_edit_id = -1;

        // remove uniform
        this.uniform_edit = {
          primary_color: "",
          secondary_color: "",
          type: "",
          pants_color: "",
          socks_color: ""
        };
      }

      // remove errors
      this.error.uniform_edit = {
        primary_color: false,
        secondary_color: false,
        type: false,
        pants_color: false,
        socks_color: false
      };
    },

    selectedUniform(id, type) {
      // loop for each uniform
      for (let i in this.uniforms) {
        // check in the list for the uniform id
        if (this.uniforms[i].id == id) {
          // assign (first, check the type)
          type == 1
            ? (this.local_equipment = this.uniforms[i])
            : (this.away_equipment = this.uniforms[i]);
        }
      }
    },

    uniformsAreEquals(uniform1, uniform2, sport) {
      let equals = false;

      if ((sport = "football")) {
        if (
          uniform1.type == uniform2.type &&
          uniform1.primary_color == uniform2.primary_color &&
          uniform1.secondary_color == uniform2.secondary_color &&
          uniform1.pants_color == uniform2.pants_color &&
          uniform1.socks_color == uniform2.socks_color
        ) {
          equals = true;
        }

        // basketball
      } else {
        if (
          uniform1.type == uniform2.type &&
          uniform1.primary_color == uniform2.primary_color &&
          uniform1.secondary_color == uniform2.secondary_color &&
          uniform1.pants_color == uniform2.pants_color
        ) {
          equals = true;
        }
      }

      return equals;
    }
  },

  watch: {
    local_equipment_mode: function() {
      if (this.local_equipment_mode == 1) {
        // assign the first equipment when swith mode
        if (
          typeof this.uniforms[Object.keys(this.uniforms)[0]] !== "undefined"
        ) {
          this.local_equipment = this.uniforms[Object.keys(this.uniforms)[0]];
        } else {
          this.local_equipment = {
            primary_color: "",
            secondary_color: "",
            type: "",
            pants_color: "",
            socks_color: ""
          };
        }

        this.local_equipment_is_preview = true;
      }
      if (this.local_equipment_mode == 2) {
        this.local_equipment_is_preview = false;
      }
    },

    away_equipment_mode: function() {
      if (this.away_equipment_mode == 1) {
        // assign the first equipment when swith mode
        if (
          typeof this.uniforms[Object.keys(this.uniforms)[0]] !== "undefined"
        ) {
          this.away_equipment = this.uniforms[Object.keys(this.uniforms)[0]];
        } else {
          this.away_equipment = {
            primary_color: "",
            secondary_color: "",
            type: "",
            pants_color: "",
            socks_color: ""
          };
        }

        this.away_equipment_is_preview = true;
      }
      if (this.away_equipment_mode == 2) {
        this.away_equipment_is_preview = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}

#content {
  #uniform_form {
    position: relative;
    height: auto;
    padding: 0 20px 20px 20px;
    overflow: auto;
    width: 100%;

    .body {
      overflow: auto;
      padding: 15px;
      h2 {
        text-align: center;
        color: black;
        font-family: AvantGarde-Bold;
        font-size: 32px;
      }

      #equipment {
        .uniform {
          margin-top: 75px;
        }
        .uniform,
        .selects {
          width: 50%;
          height: 100%;
          vertical-align: top;
          display: inline-block;
        }
      }
    }
    .buttons {
      width: 100%;
      height: 40px;
      margin-top: 25px;

      .btn {
        width: calc(50% - 20px);
        margin: 0 10px;
        display: inline-block;
        min-width: 40px;
        padding: 0 35px;
        outline: none;
        border: none;
        cursor: pointer;
        text-align: center;
        font-size: 16px;
        border-radius: 3px;
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
        background-color: #172654;
        color: #fff;
        height: 40px;
        line-height: 40px;
        text-transform: uppercase;
        background-color: #fc8926;
        font-family: AvantGarde-Bold;
        max-width: 300px;
        transition: background-color 0.5s ease;

        &#add {
          border: 1px solid #fc8926;

          &:hover {
            background-color: #e78026;
            border-color: #e78026;
          }
        }

        &#cancel {
          background-color: transparent;
          color: #c55c00;
          border: 1px solid #fc8926;

          &:hover {
            background-color: #fc8a2623 !important;
          }
        }
      }
    }
  }

  .form {
    padding-top: 25px;

    .title {
      font-family: AvantGarde-Bold !important;
    }
  }

  .box {
    @include display-flex();
    @include flex-direction(row);
    @include flex-wrap(wrap);
    margin: 0 auto;
    width: 100%;
    max-width: 900px;
    overflow: auto;
    text-align: center;

    .item.equip .content {
      border-right: 2px dotted #eee;
      padding: 0 20px;
    }

    .item.equip + .item.equip .content {
      border-right: none;
    }

    .obligatory {
      width: 100%;
      color: $alert-color;
      font-weight: bold;
      font-size: 20px;
    }

    .item {
      width: calc(50% - 20px);
      margin: 10px;
      display: inline-block;

      &.equip {
        .equipments {
          @include display-inline-flex();
          @include justify-content(center);
          @include flex-wrap(wrap);
          width: 100%;
        }

        .equipments.card {
          .single {
            margin: 10px;

            #equipment {
              padding: 12px;
              border-radius: 3px 3px 0 0;
              background-color: #fff;
              max-width: 150px !important;
              display: inline-block;
              margin: 0 12px;
              border: 2px solid #ddd;
              cursor: pointer;
              transition-duration: 0.1s;

              &:hover {
                // transform: translate(0px, -3px);
              }

              &.selected {
                background-color: #fff2e1;
                border-color: #fc8926;
              }

              &.empty {
                opacity: 0.1;
              }

              &.error {
                border: 2px solid transparent;
                border-color: $alert-color;
              }
            }

            .actions {
              width: 100%;
              display: block;
              padding: 6px;
              border-radius: 0 0 3px 3px;
              background-color: #ddd;
              cursor: pointer;
              text-align: center;
              margin: 0 12px;
              font-size: 17px;
              font-weight: bold;
              font-family: AvantGarde-Bold;
              text-transform: uppercase;
              &:hover {
                background-color: #fff2e1;
              }
            }
          }
        }
      }

      label {
        font-size: 14px;
        padding: 0;
        margin-bottom: 5px;
        display: block;
      }

      .upper {
        text-transform: uppercase;
        &::placeholder {
          text-transform: none;
        }
      }
      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 20px;
      }

      .error {
        border-color: $alert-color;
        &::placeholder {
          color: $alert-color;
          opacity: 0.5;
        }
      }

      input,
      select {
        width: 100%;
        padding: 15px;
        margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
        }
      }

      input:disabled {
        background-color: #ddd;
        cursor: not-allowed;
        opacity: 0.5;
      }

      select {
        background-image: url("/img/sort-down.svg");
        background-size: 10px;
        background-position: right 10px center;
        background-repeat: no-repeat;
      }

      .image {
        width: 100%;
        padding: 0 40px 0 0px;
        overflow: hidden;

        img,
        .addthumb {
          width: auto;
          border: 1px solid #ccc;
          // height: 100px;
          position: relative;
          cursor: pointer;
        }
        .addthumb div {
          width: 100%;
          display: block;
          top: 35%;
          position: absolute;
          text-align: center;
        }
        .addthumb .text {
          top: 60%;
        }
      }

      .add {
        border: 2px dashed #eee;
        text-align: center;
        min-height: 100px;
        padding-top: 15px;

        .text {
          text-align: center;
        }
      }

      .add_error {
        border: 1px solid $alert-color;
        text-align: center;
        .text {
          text-align: center;
          color: $alert-color;
        }
        .icon {
          color: $alert-color;
        }
      }

      .error {
        border-color: red !important;
        &::placeholder {
          color: $alert-color !important;
          opacity: 1;
        }
        .v-input__slot {
          border-color: $alert-color;
        }
        .vti__input {
          border-color: red !important;
        }
        color: red;
        font-weight: bold;
      }
    }

    select option {
      font-size: 11pt;
      background: $dark-color;
      color: $secondary-color;
    }
  }
}

@include media("<=desktop") {
  #app {
    #content {
      .box {
        .image {
          padding: 0;
          img {
            display: block;
            margin: 0 auto;
          }
        }

        .item {
          width: 100%;
          display: block;
          margin: 0 0 20px 0;

          &.equip {
            margin-bottom: 40px;
          }
        }
      }
    }
  }
}
</style>
